"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenProvider = void 0;
//TODO: Remove user id when API's supports it
var createTokenProvider = function () {
    var authToken = null;
    var userId = null;
    var getToken = function () {
        return authToken;
    };
    var setToken = function (token) {
        authToken = token;
    };
    var getUserId = function () {
        return userId;
    };
    var setUserId = function (id) {
        userId = id;
    };
    return {
        getToken: getToken,
        setToken: setToken,
        getUserId: getUserId,
        setUserId: setUserId
    };
};
exports.createTokenProvider = createTokenProvider;
var tokenProvider = (0, exports.createTokenProvider)();
exports.default = tokenProvider;
